export const NAVBAR_LINKS = [
  // {
  //   id: 2,
  //   name: "movies",
  //   url: "movies",
  //   icon: "video_library"
  // },
  // {
  //   id: 3,
  //   name: "celebrities",
  //   url: "celebrities",
  //   icon: "wc"
  // },
  {
    id: 4,
    name: "search",
    url: "search",
    icon: "search"
  }
]